import { render } from "./InplaySlider.vue?vue&type=template&id=8980ab52&scoped=true"
import script from "./InplaySlider.vue?vue&type=script&lang=js"
export * from "./InplaySlider.vue?vue&type=script&lang=js"

import "./InplaySlider.vue?vue&type=style&index=0&id=8980ab52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8980ab52"]])

export default __exports__